import React from 'react'
import { useTranslation } from 'react-i18next'

import StartEndDateRangeFields from '../../../../../ReusableFormFields/StartEndDateRangeFields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function DigitalCampaignDatesSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Campaign Dates')}</h3>
      <p>
        {t(
          'Please enter the earliest start and latest end date that a partner can create campaigns within. The partner will only be given the option to create campaigns within these dates.'
        )}
      </p>
      <StartEndDateRangeFields formik={formik} />
    </section>
  )
}

export default DigitalCampaignDatesSection
